/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('PublicFolderLinkController', [
        '$modalInstance',
        '$scope',
        '$translate',
        'DateTools',
        'confirmAction',
        'PublicFolderLinkResource',
        'dateFilter',
        'flashMessagesService',
        'isEditing',
        'publicFolderLink',
        'node',
        'operationComplete',
        function (
            $modalInstance,
            $scope,
            $translate,
            DateTools,
            confirmAction,
            PublicFolderLinkResource,
            dateFilter,
            flashMessagesService,
            isEditing,
            publicFolderLink,
            node,
            operationComplete
        ) {
            const MIN_EXPIRATION_DATE = DateTools.addDays(new Date, 1);
            const MAX_EXPIRATION_DATE = DateTools.addDays(new Date, 60);
            const DEFAULT_EXPIRATION_DATE = DateTools.addDays(new Date, 7);
            const defaultPublicFolderLinkData = {
                allow_downloading: false,
                access_restriction: 'public',
                password: null,
                expiration_date: dateFilter(DEFAULT_EXPIRATION_DATE, 'yyyy-MM-dd')
            }

            $scope.modal = $modalInstance.options;
            $scope.isEditing = isEditing;
            $scope.isSubmitting = false;
            $scope.isExpirationDateCalendarOpened = false;
            $scope.expirationMinDate = MIN_EXPIRATION_DATE;
            $scope.expirationMaxDate = MAX_EXPIRATION_DATE;
            $scope.publicFolderLink = isEditing ? publicFolderLink : defaultPublicFolderLinkData;
            $scope.publicFolderLink.isPublicWithPassword = function () {
                return $scope.publicFolderLink.access_restriction === 'public_with_password';
            };

            Object.defineProperties($scope, {
                saveButtonLabel: {
                    get: function () {
                        return isEditing ?
                            'public_folders_edit_link_modal_save_button_label' :
                            'public_folders_create_link_modal_create_button_label';
                    }
                }
            });

            $scope.disableSubmit = function () {
                return $scope.isSubmitting || ($scope.publicFolderLink.isPublicWithPassword() && !$scope.publicFolderLink.password);
            }

            $scope.close = $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.onFormSubmit = function () {
                $scope.isSubmitting = true;

                if ($scope.publicFolderLink.expiration_date instanceof Date) {
                    $scope.publicFolderLink.expiration_date = dateFilter(
                        $scope.publicFolderLink.expiration_date,
                        'yyyy-MM-dd'
                    );
                }

                if (isEditing) {
                    return PublicFolderLinkResource.update({node_uuid: node.uuid}, $scope.publicFolderLink).$promise
                        .then(function () {
                            $modalInstance.close();
                            operationComplete('Operation successful.');
                        })
                        .finally(function () {
                            $scope.isSubmitting = false;
                        });
                } else {
                    return PublicFolderLinkResource.save({node_uuid: node.uuid}, $scope.publicFolderLink).$promise
                        .then($modalInstance.close)
                        .finally(function () {
                            $scope.isSubmitting = false;
                        });
                }
            };

            $scope.revoke = function () {
                confirmAction($scope, {
                    confirmTitle: $translate.instant('public_folders_revoke_link_dialog_title'),
                    confirmSubmit: $translate.instant('public_folders_revoke_link_confirm_modal_button_label'),
                    confirmBody: $translate.instant(
                        'public_folders_revoke_link_dialog_message',
                        {
                            folder_name: node.name,
                            expiration_date: $scope.publicFolderLink.expiration_date
                        }
                    )
                }).then(function () {
                    $scope.isSubmitting = true;

                    return PublicFolderLinkResource.delete({node_uuid: node.uuid}).$promise;
                })
                    .then(function () {
                        $modalInstance.close();
                        operationComplete('Operation successful.');
                    })
                    .catch(function (error) {
                        if (error !== 'cancel') {
                            flashMessagesService.add(
                                $translate.instant('public_folders_edit_link_request_error_message'),
                                flashMessagesService.ERROR
                            );
                        }
                    })
                    .finally(function () {
                        $scope.isSubmitting = false;
                    });
            }
        }
    ]);
